<script setup lang="ts">
import { ChevronDown } from "@lucide/vue";
import { SelectScrollDownButton, type SelectScrollDownButtonProps } from "radix-vue";

const props = defineProps<SelectScrollDownButtonProps>();
</script>

<template>
	<SelectScrollDownButton
		v-bind="props"
		:class="['flex cursor-default items-center justify-center py-1', $attrs.class]"
	>
		<slot>
			<ChevronDown class="size-4" />
		</slot>
	</SelectScrollDownButton>
</template>
